<template>
    <div :style="getStyle">
        <button
            class="btn btn-sm btn-confirm button-component"
            :style="{'background-color': getBackgroundColor }"
            :disabled="!getActive"
            :class="!getActive ? 'mark-disabled' : ''"
            v-popover:tooltip="t(getTitle)"
            @click.prevent="onClick">
            {{ t(getName) }}
        </button>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        config: {
            type: Object,
            default: function () {
                return {
                    name: null,
                    backgroundColor: null,
                    title: null,
                    active: true,
                    emitEvents: [],
                    uploadFile: false,
                }
            }
        },
        parentState: {
            type: Object,
        },
        eventManager: {
            type: Object,
        },
        row: {
            type: Object,
        },
        rowIndex: {
            type: Number
        },
        columnIndex: {
            type: Number,
        },
    },
    data() {
        return {
            active: true,
            name: null,
            title: null,
            backgroundColor: null,
        };
    },
    computed: {
        getStyle() {
            return this.config.style || {margin: "1px", float: "left"};
        },
        getActive() {
            return this.active;
        },
        getBackgroundColor() {
            return this.backgroundColor;
        },
        getName() {
            return this.name;
        },
        getTitle() {
            return this.title || this.config.title;
        },
    },
    mounted() {
        this.init();
        this.mountEvents();
    },
    beforeDestroy() {
        this.eventManager.unbindEvents(this.defaultBindEvents());
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.title = this.config.title;
            this.name = this.config.name;
            this.backgroundColor = this.config.backgroundColor;
            this.active = this.config.active;
            this.internalRow = {};
        },
        defaultBindEvents() {
            return [{
                name: 'showComponent',
                componentIndex: this.componentIndex,
            }, {
                name: 'hideComponent',
                componentIndex: this.componentIndex,
            }, {
                name: 'setActive',
                componentIndex: `${this.componentIndex}-${this.columnIndex}-${this.rowIndex}}`,
            }];
        },
        hideComponent() {
            this.active = false;
        },
        setActive(active) {
            this.active = active;
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        onClick() {
            let state = this.parentState;
            this.eventManager.emitEvents(this.config.emitEvents['click'], [{
                state: state.value,
                row: this.row,
                eventData: {rowIndex: this.rowIndex}
            }]);
        },
        showComponent() {
            this.active = true;
        },
    },
}
</script>

<style lang="sass" scoped>
.mark-disabled {
    opacity: 0.4 !important;

}
.action-button-component:hover {
    opacity: 0.7 !important;

}
</style>


// WEBPACK FOOTER //
// ActionButtonComponent.vue?2bbf7498